import type { LDClientModule } from './launch-darkly.types';

// NOTE: This file is created to notify web bundler to ignore the LD native library
//       ('launchdarkly-react-native-client-sdk') dependency, as it is not required in
//       case of web bundle.

export const LaunchDarklyClientModule: LDClientModule = {
  init: async () => undefined,
};
